import { API } from '@/api'

export const getServiceStatus = (name = 'rpc_ml_service') => API.get(`/services/${name}/status/`);
export const startService = (name = 'rpc_ml_service') => API.get(`/services/${name}/start/`);
export const stopService = (name = 'rpc_ml_service') => API.get(`/services/${name}/stop/`);
export const fetchRestVersion = () => API.get(`/services/versions/`);
